module.exports = __webpack_public_path__ + "static/shambling_mound-0e74a67c9409d057901573b137276b77.png";